import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';
import FormComponent from "../../components/FormComponent";
import FormSelect from "../../components/form/FormSelect";
import Paper from "@material-ui/core/Paper";
import FormTextArea from "../../components/form/FormTextArea";
//import FormSubmitButton from "../../components/form/FormSubmitButton";
//import moment from "moment-timezone";
import Button from "@material-ui/core/Button";
import {post} from "../../modules/utility";
import AuthUserContainer from "../../containers/AuthUser";
import Zoom from "@material-ui/core/Zoom";
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from "../../images/icons/greenChecked.svg";
import kernOilExample from "../../images/arImport/sampleKernOil.jpg";
import sunPacificExample from "../../images/arImport/sunPacificExample.jpg";
import phillips66Example from "../../images/arImport/phillips66.jpg";
import FormDatePicker from "../../components/form/FormDatePicker";
import FormFileUploader from "../../components/form/FormFileUploader";
import WarningIconSvg from "../../images/icons/warningIcon.svg";


const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton : {
			marginTop : 30,
			fontSize : 16,
			borderRadius : '100px',
			padding : '12px 40px',
			textTransform: 'uppercase',
			marginRight : 10,
			lineHeight : '20px',
			height : 70,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		},
		smallWarningIcon : {
			display: 'inline-block',
			width: 35,
			height: 35,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 10,
			marginLeft : 0,
			marginTop : 0,
		},
		warningContainer : {
			borderRadius : 5,
			border : '1px solid #ccc',
			padding : 20,
			marginTop : 10,
			marginBottom : 10,
		}
	};
};

class ArImporter extends FormComponent {

	constructor(props) {
		super(props);
		this.state = {
			company: 'sunPacific',
			downloadUrl: undefined,
			isConverting: false,
			savingSuccessful: false,
			warnings : undefined,
		};
	}

	handleConversion = () => {
		const {
			showErrors,
		} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { company } = this.state;
		let params = {
			company,
		};
		if (company === 'sunPacific') {
			[
				{ path : 'depositDate', label : 'Deposit Date' },
				{ path : 'invoiceListingResourceId', label : 'Invoice listing file'},

			].forEach(({path, label}) => {
				if (!this.state[path]) {
					formFieldError[path] = `${label} is required`;
				}
			});
			['depositDate', 'invoiceListingResourceId'].forEach(path => {
				params[path] = this.state[path];
			});

		} else if (company === 'kernOil') {
			['content'].forEach(path => {
				params[path] = this.state[path];
			});

		} else if (company === 'conSw' || company === 'conNw') {
			[
				{ path : 'invoiceListingResourceId', label : 'Invoice listing file'},
			].forEach(({path, label}) => {
				if (!this.state[path]) {
					formFieldError[path] = `${label} is required`;
				}
			});
			['invoiceListingResourceId'].forEach(path => {
				params[path] = this.state[path];
			});

		} else {
			return showErrors([`Company : ${company} not found`]);
		}

		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			return showErrors(_.values(formFieldError));
		}

		this.setState({isConverting: true});

		setTimeout(() => {
			post({
				method: 'arImporter.convert',
				params,
				callback: (err, r) => {
					this.setState({
						isConverting: false,
					});

					if (err) {
						const note = 'Sometimes the conversion process takes a long time. If you are seeing this error' +
							' click continue, then click the Run Conversion button again. It will pickup where it left off.'  +
							' Do not refresh and reupload or it will start all over again.';
						return showErrors([note, err]);
					}

					const { warnings } = r;
					const resource = _.get(r, 'collections.resourceCollection.0');
					if (!resource) {
						return showErrors('Missing resource something went wrong');
					}

					const {url} = resource;

					this.setState({
						warnings,
						downloadUrl: url,
						savingSuccessful: true,
					});
				}
			});
		}, 500);
	};

	render() {
		const {
			classes,

		} = this.props;

		const {
			isConverting,
			savingSuccessful,
			warnings,
		} = this.state;

		return (<form>
			<Paper className={classes.globalMainPaper} style={{minHeight: 500}}>
				<div className={classes.globalMainHeadline}>AR Importer</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						<FormSelect
							{...this.setForm('company', 'Customer')}
							options={[
								{display: 'Kern Oil', value: 'kernOil'},
								{display: 'Sun Pacific', value: 'sunPacific'},
								{display: 'Phillips 66 (CONSW)', value: 'conSw'},
								{display: 'Phillips 66 (CONNW)', value: 'conNw'}
							]}
						/>

						{this.renderCompanyOptions()}

						{!_.isEmpty(warnings) && this.renderWarnings()}

						<Grid item xs={12} style={{display: 'flex'}}>
							<Button
								onClick={this.handleConversion}
								variant="contained"
								color="primary"
								className={classes.submitButton}
							>
								Run Conversion
							</Button>


							{this.renderDownloadButton()}

							<div style={{marginTop: 30}}>
								<Zoom
									in={isConverting}
									style={{transitionDelay: isConverting ? '0ms' : '0ms'}}
									mountOnEnter unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{verticalAlign: 'middle'}}/>
										<span style={{paddingLeft: 10}}>Converting...</span>
									</div>
								</Zoom>

								<Zoom in={savingSuccessful}
								      style={{transitionDelay: savingSuccessful ? '250ms' : '0ms'}}>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon}/>
										<span style={{paddingLeft: 10}}>Conversion Successful.</span>
									</div>
								</Zoom>
							</div>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						{this.renderCompanyHelp()}
					</Grid>
				</Grid>
			</Paper>
		</form>);
	}

	renderWarnings = () => {
		const { classes } = this.props;
		const { warnings } = this.state;
		return (<div className={classes.warningContainer}>
			{warnings.map((warning, i) => {
				return (
					<div key={i}>
						<div className={classes.smallWarningIcon}/>
						<span>{warning}</span>
					</div>
				);
			})}
		</div>);
	};


	renderCompanyHelp = () => {
		const { company } = this.state;
		if (company === 'kernOil') {
			return (<>
				<div style={{marginTop: 50}}>Example:</div>
				<img alt="diagram" src={kernOilExample}/>
			</>);
		} else if (company === 'sunPacific') {
			return (<div style={{marginLeft : 30, marginTop : 60}}>
				<div>Invoice listing file should look like this</div>
				<img style={{width:'80%'}} alt="diagram" src={sunPacificExample}/>
			</div>);
		} else if (company === 'conSw' || company === 'conNw') {
			return (<div style={{marginLeft : 30, marginTop : 60}}>
				<div>Invoice listing file should look like this</div>
				<img style={{width:'80%', border : '1px solid #999'}} alt="diagram" src={phillips66Example}/>
			</div>);
		}
	};

	renderCompanyOptions = () => {
		const { company } = this.state;

		if (company === 'kernOil') {
			return (<>
				<FormTextArea
					{...this.setForm('content', 'COPY / PASTE EMAIL CONTENT HERE')}
					rows={40}
				/>
			</>);
		} else if (company === 'sunPacific') {
			return (<>
				<FormDatePicker
					{...this.setForm('depositDate', 'Deposit Date')}
				/>

				<Grid item xs={12}>
					<FormFileUploader
						{...this.setForm('invoiceListingResourceId', 'Invoice List File')}
					/>
				</Grid>

				<Grid item xs={12}>
					<br/>
					Note : Please be patient when converting Sun Pacific. Could take up to a minute
					depending on the number of pages.
				</Grid>

			</>);
		} else if (company === 'conSw' || company === 'conNw') {
			return (<>
				<Grid item xs={12}>
					<FormFileUploader
						{...this.setForm('invoiceListingResourceId', 'Invoice List File')}
					/>
				</Grid>

				<Grid item xs={12}>
					<br/>
					Note : Please be make sure you pick the correct CONSW vs CONNW company.
				</Grid>

			</>);
		}
};

	renderDownloadButton = () => {

		const { classes } = this.props;
		const {savingSuccessful, downloadUrl } = this.state;

		const button = (
			<Button variant="contained" color="primary" className={classes.submitButton} disabled={!downloadUrl}>
			Download CSV
		</Button>);

		if (!savingSuccessful) {
			return button;
		}

		return (
			<a
				href={downloadUrl}
				style={{textDecoration: 'none', paddingRight : 5}}
				target="_blank" rel='noreferrer noopener'
			>
				{button}
			</a>
		)

	}
}

ArImporter.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
])(ArImporter);
